import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ConfigService } from '@core/Abstract/config.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { LogService } from '@core/Abstract/log.service';
import { SecurityService } from '@core/Security/security.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()

export class DynamicFormService extends SecurityService {

    constructor(http: HttpClient, configService: ConfigService, eventsEmitterService: EventsEmitterService, router: Router, logger: LogService) {
        super(http, configService, eventsEmitterService, router, logger);
    }

    /**
     * Get list of form fields / filters
     * 
     * @param params { group:string, ...0-n?:any }
     */
    getFormFieldDefinition( params: any ): Observable<any> {
        let serviceUrl = this.baseUrl + 'FormFieldDefinitionService/getFormFieldDefinitions?' + this.urlParamsToString(params);

        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
}